<div class="flex flex-col p-4" *ngIf="errors.length">
	<mat-error><mat-icon>error</mat-icon><span class="align-super">Validation Errors:</span></mat-error>
	<mat-error *ngFor="let error of errors" class="pl-8">
		{{ error.controlName }} is
		<span class="font-bold" *ngIf="error.errorName === 'required'">required.</span>
		<span class="font-bold" *ngIf="error.errorName === '!required'">invalid.</span>
	</mat-error>
</div>
